import { translate } from '@repo/phrase';
import { Container } from '@repo/ui/container';
import { NoBodyMessage } from '@repo/ui/message';

export const RouterNotFound = () => {
    return (
        <Container testId="router-not-found" padding>
            <NoBodyMessage title={translate('router_not_found_title')} body={translate('router_not_found_body')} />
        </Container>
    );
};
